export const environment = {
  apiBaseUrl: 'https://api.vinmarts.in/api/',
  ImageBaseUrl: 'https://api.vinmarts.in/uploads/images/',
  ImageBaseUrlForBanner: 'https://api.vinmarts.in/uploads/image',
  apiInvoiceUrl: 'https://api.vinmarts.in/api/invoice',

  deliveryapiBaseUrl: 'https://apiv2.shiprocket.in/v1/external/',
  razorpayBaseUrl: 'https://api.razorpay.com/v1/',
  // ImageBaseUrl: 'http://localhost:5000/uploads/images/',
  // apiBaseUrl: 'http://localhost:5000/api/',
  // apiInvoiceUrl: 'http://localhost:5000/api/invoice',
  // imageTempUrl: 'http://localhost:5000/uploads/temp',
  apiEndPoint: {
    login: 'user-login',
    logOut: 'user-logout',
    register: 'user-register',
    forgotPassword: 'forget-password',
    verifyotp: 'verified',
    reSend: 'resend-otp',
    changePassword: 'update-password',
    getUserDetail: 'user-account',
    updateProfile: 'user-update-account',
    addAddress: 'save-delivery-address',
    getAllUserAddress: 'get-all-users-deliveryaddress',
    getAddressById: 'address',
    deleteAddressById: 'address/delete',
    defaultDeliveryAddress: '/default-delivery-address',

    getBanners: 'get-banners',
    getCatagories: 'getActiveCategories',
    getAllCategories: 'get-all-categories',
    getAllWalletList: 'get-all-categories',
    allProducts: 'allProducts',
    allActiveProducts: 'product-list',
    productDetails: 'products',
    getProductsByCategory: 'getProductsByCategory',
    getVendorsProduct: 'vendors-products',
    cartList: 'cart-list',
    cartUpdate: 'cart-update',
    deleteCartItem: 'cart',
    addToCart: 'add-to-cart',
    getOrdersList: 'user/orders',
    getOrderById: 'user/orders',
    getStates: 'states',
    checkOut: 'checkout',
    // rating: 'add-rating',
    addRatingReview: 'add-review',

    getWishlist: 'get-wishlist-product',
    addWishlist: 'add-wishlist-product',
    removeWishlist: 'remove-wishlist-product',

    applyCoupon: 'apply-coupon',
    updateReward: 'updateReward',

    orderCancel: 'order-cancel',
    addBankInfo: 'user-update-bankinfo',

    sellerStoreDetails: 'store',
    sellerCategory: 'seller',
    SellerProduct: 'store',
    getSellerNewlyArrivedProducts: 'GetNewlyArrivedProducts',
    getSellerTopQualityProducts: 'GetTopQualityProducts',
    getSellerBestOfferProducts: 'GetBestOfferProducts',
    GetPopularProductsBySeller: 'GetPopularProductsBySeller',

    //delivery api shiprocket
    checkSeviceAbailbility: 'courier/serviceability/',
    createCustomOrder: 'orders/create/adhoc',
    trackingOrder: 'courier/track/awb/',

    // updateRecentlyViewed: '/update-recently-viewed',
    // getRecentlyViewed: '/:userId/recently-viewed',

    recentViewProduct: 'recently-viewed-products',
    similarProduct: 'product',

    prodcutSearch: 'product-search',
    allOrderTransaction: 'all-order-transactions',
    userReviews: 'user-reviews',
  },
};
// https://apiv2.shiprocket.in/v1/external/courier/track/awb/19041604839965
